const API = 'https://doctors-booking-api-162q.onrender.com/api/v1';

export default API;
